import { marks as basicMarks } from 'prosemirror-schema-basic';
import { MarkSpec } from 'prosemirror-model';

const strikethrough: MarkSpec = {
  parseDOM: [
    { tag: 'strike' },
    { style: 'text-decoration=line-through' },
    { style: 'text-decoration-line=line-through' },
  ],
  toDOM: () => [
    'span',
    {
      style: 'text-decoration-line:line-through',
    },
  ],
};

const underline: MarkSpec = {
  parseDOM: [{ tag: 'u' }, { style: 'text-decoration=underline' }],
  toDOM: () => [
    'span',
    {
      style: 'text-decoration:underline',
    },
  ],
};

export const marks = {
  ...basicMarks,
  strikethrough,
  underline,
};
